import {
    AnimationBaseController,
    GameApiBase,
    GameRandom,
    GameStorageManager,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../../AnimationContents';
import {
    ButtonController,
    IButtonControllerOptions,
} from '../../../Common/ButtonController';
import { GameModel } from '../../../Models/Game/GameModel';
import { GameLogic } from '../../../Logic/GameLogic';
import {
    IPauseButtonControllerOptions,
    PauseControllerButton,
} from './PauseControllerButton';

export class PauseController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options,
        @Inject private _random: GameRandom,
        @Inject private _gameLogic: GameLogic,
        @Inject private readonly _storageManager: GameStorageManager,
        @Inject private _arenaApi: GameApiBase
    ) {
        super('PauseController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.PAUSE_SCREEN_JSON,
            libraryName: 'main',
            childControllers: {
                buttonPause: {
                    instanceName: 'window.container.btn_close',
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.gotoAndPlay('window close');
                            this.$queue.get('hidePause').addToQueue();
                        },
                    },
                },
            },
            modelWatch: {
                // showPause: (showPause: boolean) => {
                //     this.visible = true;
                //     if (showPause) {
                //         this.gotoAndPlay("window initialization");
                //     } else {
                //         this.gotoAndPlay("window close");
                //         this.$queue.get("hidePause").addToQueue()
                //     }
                // },
            },
            queue: {
                hidePause: {
                    condition: time => time > 0.3,
                    action: () => {
                        this._gameLogic.resetGamePause();
                    },
                },
            },
        };
    }

    protected onInitialize(): void {
        [
            'continue',
            'restart',
            'settings',
            'rules',
            'achievements',
            'man_menu',
        ].forEach((name: string) => {
            this.addChildController(
                {
                    instanceName: `window.container.btn_${name}`,
                    view: PauseControllerButton,
                    model: name,
                    options: <IPauseButtonControllerOptions>{
                        name: name,
                        onClick: name => {
                            switch (name) {
                                case 'continue':
                                    this.gotoAndPlay('window close');
                                    this.$queue.get('hidePause').addToQueue();
                                    break;

                                case 'restart':
                                    this._gameLogic.showPauseRestart();
                                    break;

                                case 'settings':
                                    this._gameLogic.showPauseSettings();
                                    break;

                                case 'rules':
                                    this._gameLogic.showPauseRules();
                                    break;

                                case 'achievements':
                                    this._gameLogic.showPauseAchievements();
                                    break;

                                case 'man_menu':
                                    this._gameLogic.showPauseToMenu();
                                    break;
                            }
                        },
                    },
                },
                name
            );
        });
    }

    protected onLandscape(): void {
        this.display.scale.set(1.4);
        this.display.y = 25;
    }
}
